import type {ReactNode} from 'react'
import {useMilestoneQuery} from './data/route-queries'
import {SidebarMilestonePicker} from './SidebarMilestonePicker'
import {SidebarSection} from './SidebarSection'

export function MilestoneSection({children}: {children: ReactNode}) {
  const {data} = useMilestoneQuery()
  // Viewers who can't set the milestone get the static header instead of a picker.
  const canSetMilestone = !data || data.viewerCanSetMilestone

  return (
    <SidebarSection title="Milestone" header={canSetMilestone ? <SidebarMilestonePicker /> : undefined}>
      {children}
    </SidebarSection>
  )
}
